<template>
    <div>
        <Language v-model="form.lang" @change="handleLangChange"></Language>
        <el-form size="mini" label-width="50px">
            <el-form-item label="封面"><img v-if="form.cover" style="height: 80px" :src="ossUrl + form.cover" /></el-form-item>
            <el-form-item label="标题">{{ form.name }}</el-form-item>
            <el-form-item label="分类">{{ form.category.name }}</el-form-item>
            <el-form-item label="详情"><span style="position: relative; top: -12px" v-html="form.detail"></span></el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import { detail } from "@/api/case/list";
import { ossUrl } from "@/configs/oss";
export default {
    components: { Language },
    data() {
        return {
            ossUrl,
            form: {
                lang: "zh",
                category: {},
            },
        };
    },
    mounted() {
        this.form.cuuid = this.$route.query.cuuid;
        this.getDetail();
    },
    methods: {
        handleLangChange() {
            this.getDetail();
        },
        getDetail() {
            detail({ cuuid: this.form.cuuid, lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.form = { ...result, category: result.category ? result.category : {} };
                    } else {
                        this.form = { lang: this.form.lang, cuuid: this.form.cuuid, category: {} };
                    }
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
